import React from 'react';

const Checkbox = ({ id, type, name, handleClick, isChecked }) => {
  return <input id={id} name={name} type={type} onChange={handleClick} checked={isChecked} data-cy={`checkbox-${name}`} />;
};

export default Checkbox;
